export default {"src":"/_next/static/media/7_points_icon.94040991.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};